import { usePrivy } from "@privy-io/react-auth";
import { useQuery } from "@tanstack/react-query";
import { getWalletsByPrivyUserId } from "data/supabase/privyUserWallets";

export function usePrivyUserMetadata() {
  const { user } = usePrivy();

  const { data: linkedWallets = [] } = useQuery({
    queryKey: ["privyUserWallets", user?.id] as const,
    queryFn: ({ queryKey: [, privyUserId] }) => {
      if (!privyUserId) throw new Error("Privy user ID is required");
      return getWalletsByPrivyUserId(privyUserId);
    },
    enabled: Boolean(user?.id),
    refetchOnWindowFocus: false,
  });

  return { linkedWallets };
}
